import {
  GetServerSidePropsContext,
  InferGetServerSidePropsType,
  NextPageWithLayout,
} from "next";
import loadNamespaces from "next-translate/loadNamespaces";
import React, { ReactElement } from "react";
import { jsonDeserialize, jsonSerialize } from "~/lib/utils/jsonHelper";
import { generateQaPreviewData } from "~/services/questionAnswers/ssrData/preview";
import WithToastLayout from "faqSrc/components/layout/AppLayout/WithToastLayout";
import TemplateAnswerReview from "faqSrc/components/templates/questions/questionAnswer/review";
import { pagesPath } from "faqSrc/lib/$path";

interface Param {
  questionAnswerId: string;
  topicSlug: string;
}

export const getServerSideProps = async (
  context: GetServerSidePropsContext
) => {
  const { questionAnswerId } = context.params as unknown as Param;
  const initialData = await generateQaPreviewData({
    mode: "review",
    questionAnswerId,
  });

  return {
    props: {
      ...(await loadNamespaces({
        locale: context.locale,
        pathname: pagesPath.qa
          ._topicSlug("")
          ._questionAnswerId("")
          .review.$url().pathname,
      })),
      ...jsonSerialize(initialData),
    },
  };
};

type Props = InferGetServerSidePropsType<typeof getServerSideProps>;

const PageQaReview: NextPageWithLayout<Props> = (props) => (
  <TemplateAnswerReview {...jsonDeserialize(props)} />
);

PageQaReview.getLayout = function getLayout(page: ReactElement) {
  return <WithToastLayout>{page}</WithToastLayout>;
};

export default PageQaReview;
